module.exports = __webpack_public_path__ + "img/icon_production_en.65442a94.png";